import { useState } from "preact/hooks";
import { apiFetch, setCreds } from "../api";

interface Props {
  onAuth: () => void;
}

export function Login({ onAuth }: Props) {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: Event) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    setCreds({ user, pass });
    try {
      const res = await apiFetch("/api/me");
      if (res.ok) {
        onAuth();
        return;
      }
      setCreds(null);
      setErr(
        res.status === 401
          ? "Invalid credentials"
          : res.status === 503
            ? "Admin not configured on the Worker"
            : `Error ${res.status}`,
      );
    } catch (e) {
      setCreds(null);
      setErr(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="login">
      <form onSubmit={submit}>
        <h1>ICMAA Admin</h1>
        <label>
          User
          <input
            autoFocus
            value={user}
            onInput={(e) => setUser((e.target as HTMLInputElement).value)}
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={pass}
            onInput={(e) => setPass((e.target as HTMLInputElement).value)}
            required
          />
        </label>
        {err && <div class="error">{err}</div>}
        <button type="submit" disabled={busy}>
          {busy ? "..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
